import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import logo_apiiro from "../img/companies/apiiro.jpg";
import logo_workday from "../img/companies/workday.jpg";
import logo_hiredscore from "../img/companies/hiredscore.jpg";
import logo_optimove from "../img/companies/optimove.jpg";
import logo_indegy from "../img/companies/indegy.jpg";
import logo_toyga from "../img/companies/toyga.jpg";
import logo_golden_lines from "../img/companies/golden-lines.jpg";
import logo_intel_labs from "../img/companies/intel-labs.jpg";
import logo_tel_hai from "../img/companies/tel-hai.jpg";
import profilePhoto from "../img/kfir-profile.jpg";   // same photo as LinkedIn
import {Wrap} from "./games";
import {LargeTitle, Section, SectionTitle, Group, Row, Reveal, WHATSAPP_URL, SiteFooter, glass, filled, capsule} from "../ui";

const LINKEDIN_URL = "https://www.linkedin.com/in/millerkfir/";
const CAREER_START = 2005;

// from LinkedIn (newest first)
const EXPERIENCE = [
    {company: "Apiiro", logo: logo_apiiro, url: "https://www.linkedin.com/company/13057840/", roles: ["Software Development Engineer"], years: "2024 – היום", current: true, note: "אבטחת קוד בעידן שבו סוכני AI כותבים אותו", color: ["#22c55e", "#15803d"]},
    {company: "Workday", logo: logo_workday, url: "https://www.linkedin.com/company/17719/", roles: ["Sr Software Development Engineer"], years: "2024", note: "לאחר ש־Workday רכשה את HiredScore", color: ["#fbbf24", "#d97706"]},
    {company: "HiredScore", logo: logo_hiredscore, url: "https://www.linkedin.com/company/3345089/", roles: ["Head of Incubation", "Senior Full Stack Engineer"], years: "2020 – 2024", note: "הקמתי והובלתי מוצרים חדשים מאפס, יד ביד עם הלקוחות", color: ["#818cf8", "#4f46e5"]},
    {company: "Optimove", logo: logo_optimove, url: "https://www.linkedin.com/company/227901/", roles: ["Front End Tech Leader", "Senior Front End Developer"], years: "2018 – 2020", color: ["#f472b6", "#db2777"]},
    {company: "Indegy", logo: logo_indegy, url: "https://www.linkedin.com/company/5275742/", roles: ["Software Development Engineer"], years: "2017 – 2019", note: "אבטחת סייבר למערכות תעשייתיות", color: ["#38bdf8", "#0284c7"]},
    {company: "TOYGA", logo: logo_toyga, url: "https://www.linkedin.com/company/4987657/", roles: ["Developer"], years: "2011 – 2017", color: ["#fb923c", "#ea580c"]},
    {company: "012 Golden Lines", logo: logo_golden_lines, url: "https://www.linkedin.com/company/16257/", roles: ["Web Developer"], years: "2008 – 2010", color: ["#facc15", "#ca8a04"]},
    {company: "Intel Labs", logo: logo_intel_labs, url: "https://www.linkedin.com/company/727974/", roles: ["מורה לבניית אתרים"], years: "2005 – 2008", color: ["#60a5fa", "#1d4ed8"]},
];
const VISIBLE_UNTIL = "Indegy";   // everything after it sits behind "הצג עוד"

const SKILL_GROUPS = [
    {title: "Frontend", color: "#007aff", icon: "screen", items: ["React", "TypeScript", "Redux", "HTML & CSS"]},
    {title: "Backend", color: "#34c759", icon: "server", items: ["C#", "Node.js", "Python"]},
    {title: "דאטה ותשתיות", color: "#ff9500", icon: "stack", items: ["MongoDB", "ClickHouse", "Elasticsearch", "Redis", "RabbitMQ", "Kubernetes"]},
    {title: "איך אני עובד", color: "#af52de", icon: "spark", items: ["Full-Stack", "ארכיטקטורה", "פיתוח בעזרת AI", "בניית סוכני AI", "Claude Code", "Codex"]},
];

const yearsSince = (y, mmdd) => {
    const now = new Date();
    let n = now.getFullYear() - Number(y);
    if (mmdd) {
        const [m, d] = mmdd.split('-').map(Number);
        if (now.getMonth() + 1 < m || (now.getMonth() + 1 === m && now.getDate() < d)) n--;
    }
    return n;
};


export const About = () => {

    return (
        <div className="page page-games">
            <AboutWrap>
                <Top>
                <Hero>
                    <Reveal>
                        <Portrait src={profilePhoto} alt="כפיר מילר"/>
                    </Reveal>
                    <Reveal delay={60}>
                        <Eyebrow>מי אני</Eyebrow>
                        <LargeTitle as="h1" className="hero-name">כפיר מילר</LargeTitle>
                        <Role>מהנדס תוכנה ב־<bdi>Apiiro</bdi> · תל אביב</Role>
                    </Reveal>
                    <Reveal delay={120}>
                        <Actions className="actions">
                            <Pill data-glass href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" $primary>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.75h4v11H3zM9.5 9.75h3.8v1.6h.06c.53-1 1.82-2.05 3.75-2.05 4 0 4.74 2.6 4.74 6v5.45h-4v-4.8c0-1.15-.02-2.62-1.6-2.62-1.6 0-1.85 1.25-1.85 2.54v4.88h-4z"/></svg>
                                LinkedIn
                            </Pill>
                            <Pill data-glass href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.3.5-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/></svg>
                                וואטסאפ
                            </Pill>
                        </Actions>
                    </Reveal>
                </Hero>

                <Reveal>
                    <Glance>
                        <Stat><b dir="ltr"><CountUp to={yearsSince(CAREER_START)} suffix="+"/></b><span>שנים בפיתוח</span></Stat>
                        <Stat><b><CountUp to={EXPERIENCE.length} delay={120}/></b><span>חברות</span></Stat>
                        <Stat><b dir="ltr"><CountUp to={2400} suffix="+" delay={240} duration={1700}/></b><span>עוקבים בלינקדאין</span></Stat>
                    </Glance>
                </Reveal>
                </Top>

                <Columns>
                    <MainCol>
                    <Reveal as={Section}>
                        <SectionTitle>קצת עליי</SectionTitle>
                        <Card>
                            <Lead>יש מי שרואה דף ריק. אני רואה מוצר שמחכה להיוולד.</Lead>
                            <Body>למעלה משני עשורים אני מלווה רעיונות בדרכם אל העולם: מן השרטוט הראשון ומשורת הקוד הראשונה, עד מערכות שעומדות איתנות מול עומסים של ממש. בניתי מערכות עיצוב לתאגידים מרשימת Fortune 500 והקמתי מוצרים יש מאין, יד ביד עם הלקוחות.</Body>
                            <Body>בשנים האחרונות הבינה המלאכותית היא שותפתי ליצירה. Claude Code ו־Codex הם כלי העבודה שלי יום־יום, בזכותם אני בונה בקצב שלא היה אפשרי רק לפני שנים ספורות, מפתח סוכני AI שנוטלים על עצמם עבודה של ממש.</Body>
                            <Body>חוויית משתמש סבוכה, צוואר בקבוק שחונק את השרת, או חזון שמבקש להפוך למציאות כבר אתמול: שם אני מרגיש בבית.</Body>
                        </Card>
                    </Reveal>
    
                    <Reveal as={Section}>
                        <SectionTitle>ניסיון</SectionTitle>
                        <Experience/>
                    </Reveal>
    
                    </MainCol>
                    <SideCol>
                    <Reveal as={Section}>
                        <SectionTitle>התחומים שלי</SectionTitle>
                        <SkillGrid>
                            {SKILL_GROUPS.map((g) => (
                                <SkillCard key={g.title} style={{'--c': g.color}}>
                                    <SkillHead>
                                        <SkillIcon>{SKILL_ICONS[g.icon]}</SkillIcon>
                                        <bdi>{g.title}</bdi>
                                    </SkillHead>
                                    <Chips>
                                        {g.items.map((s) => <Chip key={s}><bdi>{s}</bdi></Chip>)}
                                    </Chips>
                                </SkillCard>
                            ))}
                        </SkillGrid>
                    </Reveal>
    
                    <Reveal as={Section}>
                        <SectionTitle>השכלה</SectionTitle>
                        <Group>
                            <Row>
                                <AppIcon><img src={logo_tel_hai} alt="" loading="lazy"/></AppIcon>
                                <RowText><strong>המכללה האקדמית תל־חי</strong></RowText>
                            </Row>
                        </Group>
                    </Reveal>
    
                    <Reveal as={Section}>
                        <SectionTitle>צרו קשר</SectionTitle>
                        <Group>
                            <LinkRow as="a" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                                <AppIcon style={{background: "linear-gradient(180deg, #5bea7a, #1fb84a)"}}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.3.5-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/></svg>
                                </AppIcon>
                                <RowText><strong>וואטסאפ</strong><small>שלחו לי הודעה</small></RowText>
                                <Chevron/>
                            </LinkRow>
                            <LinkRow as="a" $inset={68} href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
                                <AppIcon style={{background: "linear-gradient(180deg, #1a86e0, #0a66c2)"}}>
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.75h4v11H3zM9.5 9.75h3.8v1.6h.06c.53-1 1.82-2.05 3.75-2.05 4 0 4.74 2.6 4.74 6v5.45h-4v-4.8c0-1.15-.02-2.62-1.6-2.62-1.6 0-1.85 1.25-1.85 2.54v4.88h-4z"/></svg>
                                </AppIcon>
                                <RowText><strong>LinkedIn</strong><small dir="ltr">linkedin.com/in/millerkfir</small></RowText>
                                <Chevron/>
                            </LinkRow>
                        </Group>
                    </Reveal>
                    </SideCol>
                </Columns>

                <SiteFooter contact={false}/>
            </AboutWrap>
        </div>
    );
};

const AboutWrap = styled(Wrap)`
    max-width: 1120px;
`;

/* desktop: story + experience on the right, quick facts on the left (sticks while you read) */
const Columns = styled.div`
    @media (min-width: 980px) {
        display: grid;
        grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
        gap: 32px;
        align-items: start;
    }
`;

const MainCol = styled.div`
    min-width: 0;
`;

const SideCol = styled.div`
    min-width: 0;
    /* only pin it when the whole column fits on screen */
    @media (min-width: 980px) and (min-height: 860px) {
        position: sticky;
        top: calc(var(--topbar-h) + 8px);
    }
`;

/** Counts up from 0 once it scrolls into view; settles with a long ease-out (no overshoot). */
const CountUp = ({to, suffix = '', delay = 0, duration = 1400}) => {
    const ref = useRef(null);
    const reduce = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const [n, setN] = useState(reduce ? to : 0);
    useEffect(() => {
        if (reduce) { setN(to); return; }
        const el = ref.current;
        let raf = 0, timer = 0, io = null;
        const run = () => {
            const t0 = performance.now();
            const step = (t) => {
                const p = Math.min(1, (t - t0) / duration);
                const eased = 1 - Math.pow(1 - p, 4);          // easeOutQuart: fast start, gentle landing
                setN(Math.round(to * eased));
                if (p < 1) raf = requestAnimationFrame(step);
            };
            raf = requestAnimationFrame(step);
        };
        const start = () => { timer = setTimeout(run, delay); };
        if ('IntersectionObserver' in window && el) {
            io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); start(); } }, {threshold: 0.4});
            io.observe(el);
        } else start();
        return () => { cancelAnimationFrame(raf); clearTimeout(timer); if (io) io.disconnect(); };
    }, [to, delay, duration, reduce]);
    return <span ref={ref} style={{fontVariantNumeric: 'tabular-nums'}}>{n.toLocaleString('en-US')}{suffix}</span>;
};

const Experience = () => {
    const [open, setOpen] = useState(false);
    const cut = EXPERIENCE.findIndex((e) => e.company === VISIBLE_UNTIL) + 1;
    const first = EXPERIENCE.slice(0, cut), rest = EXPERIENCE.slice(cut);
    return (
        <Timeline>
            {first.map((e) => <Job key={e.company} e={e}/>)}
            {rest.length > 0 && (
                <>
                    {/* height animates 0fr → 1fr from its current value, so it can be reversed mid-way */}
                    <More className={open ? 'open' : undefined} aria-hidden={!open}>
                        <div>{rest.map((e) => <Job key={e.company} e={e}/>)}</div>
                    </More>
                    <MoreBtn data-glass type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
                        <span>{open ? 'הצג פחות' : `הצג עוד · ${rest.length}`}</span>
                        <svg className={open ? 'up' : undefined} width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M1 1.5l5 5 5-5"/></svg>
                    </MoreBtn>
                </>
            )}
        </Timeline>
    );
};

const Job = ({e}) => (
    <JobRow className={e.current ? 'current' : undefined}>
        <Rail><Dot style={{background: e.color[0]}}/></Rail>
        <Logo href={e.url} target="_blank" rel="noopener noreferrer" aria-label={`${e.company} בלינקדאין`}
              style={{background: `linear-gradient(145deg, ${e.color[0]}, ${e.color[1]})`}}>
            {e.logo ? <img src={e.logo} alt="" loading="lazy"/> : e.company[0]}
        </Logo>
        <JobText>
            <JobHead>
                <CompanyLink href={e.url} target="_blank" rel="noopener noreferrer" dir="ltr">
                    {e.company}
                    <svg width="9" height="9" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 1h6v6M9 1L1 9"/></svg>
                </CompanyLink>
                {e.current && <Now>עכשיו</Now>}
            </JobHead>
            {e.roles.map((r) => <Roleline key={r} dir="auto">{r}</Roleline>)}
            {e.note && <Note>{e.note}</Note>}
        </JobText>
        <YearPill dir="ltr">{e.years}</YearPill>
    </JobRow>
);

const Ic = ({children}) => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);
const SKILL_ICONS = {
    screen: <Ic><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 20h8M12 16v4"/></Ic>,
    server: <Ic><rect x="3.5" y="4" width="17" height="6.5" rx="1.8"/><rect x="3.5" y="13.5" width="17" height="6.5" rx="1.8"/><path d="M7 7.2h.01M7 16.7h.01"/></Ic>,
    stack: <Ic><path d="M12 3l9 4.5-9 4.5-9-4.5z"/><path d="M3 12l9 4.5 9-4.5M3 16.5L12 21l9-4.5"/></Ic>,
    spark: <Ic><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6"/></Ic>,
};

const Chevron = () => (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" stroke="var(--label-3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M7 1L1 7l6 6"/>
    </svg>
);

/* ------------------------------------------------------------------ styles */
/* desktop: the portrait block on the right, the numbers stacked on the left (same columns as below) */
const Top = styled.div`
    @media (min-width: 980px) {
        display: grid;
        grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
        gap: 32px;
        align-items: center;
        padding: 28px 0 8px;
    }
`;

const Hero = styled.div`
    position: relative;
    isolation: isolate;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 14px;
    padding: 20px 0 8px;

    .hero-name { text-align: center; }

    @media (min-width: 768px) {
        padding: 36px 0 12px;
    }
    @media (min-width: 980px) {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        column-gap: 28px;
        row-gap: 16px;
        text-align: right;
        padding: 0;
        & > :nth-child(1) { grid-row: 1 / span 2; }
        .hero-name { text-align: right; }
        .actions { justify-content: flex-start; }
    }

    /* ambient light behind the portrait (static: no looping motion) */
    &::before {
        content: "";
        position: absolute;
        z-index: -1;
        top: -10px;
        left: 50%;
        width: min(560px, 120%);
        height: 320px;
        transform: translateX(-50%);
        background:
            radial-gradient(40% 50% at 35% 45%, rgba(0, 122, 255, 0.22), transparent 70%),
            radial-gradient(40% 50% at 65% 40%, rgba(175, 82, 222, 0.18), transparent 70%),
            radial-gradient(45% 45% at 50% 70%, rgba(52, 199, 89, 0.14), transparent 70%);
        filter: blur(30px);
        pointer-events: none;
    }
    /* desktop: keep the glow behind the portrait, which now sits on the right */
    @media (min-width: 980px) {
        &::before { left: auto; right: -110px; top: -70px; width: 420px; transform: none; }
    }
`;

const Portrait = styled.img`
    width: 132px;
    height: 132px;
    border-radius: 50%;
    object-fit: cover;
    box-shadow: 0 0 0 4px var(--surface), var(--shadow-lg);
`;

const Eyebrow = styled.div`
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: var(--tint);
    margin-bottom: 4px;
`;

const Role = styled.p`
    margin: 8px 0 0;
    font-size: 17px;
    color: var(--label-2);
`;

const Actions = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
`;

const Pill = styled.a`
    ${capsule}
    ${(p) => (p.$primary ? filled : glass)}
    min-height: 48px;
    padding: 0 24px;
    ${(p) => !p.$primary && 'color: #1a9e4b;'}
`;

const Glance = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 24px;

    @media (min-width: 980px) {
        grid-template-columns: 1fr;
        gap: 10px;
        margin-top: 0;
        & > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 18px 22px;
            text-align: right;
        }
        & > div > span { margin-top: 0; font-size: 16px; font-weight: 500; order: -1; }   /* label right, number left */
        & > div > b { font-size: 34px; font-weight: 600; letter-spacing: -0.025em; }
    }
`;

const Stat = styled.div`
    background: var(--surface);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    padding: 16px 8px;
    text-align: center;

    b {
        display: block;
        font-size: 32px;
        font-weight: 800;
        line-height: 1.05;
        letter-spacing: -0.03em;
        font-variant-numeric: tabular-nums;
    }
    & > span {
        display: block;
        margin-top: 4px;
        font-size: 13px;
        color: var(--label-2);
    }
`;

const Card = styled.div`
    background: var(--surface);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    padding: 18px 18px 6px;
`;

const Lead = styled.p`
    margin: 0 0 12px;
    font-size: 21px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.02em;
`;

const Body = styled.p`
    margin: 0 0 12px;
    font-size: 17px;
    line-height: 1.55;
    color: rgba(29, 29, 31, 0.86);
`;

const RowText = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    text-align: right;

    strong { font-size: 17px; font-weight: 600; letter-spacing: -0.01em; text-align: right; }
    small { font-size: 14px; color: var(--label-2); line-height: 1.35; text-align: right; }
`;

const pressable = `
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition: background-color 200ms ease;
    &:active { background-color: rgba(0, 0, 0, 0.06); transition-duration: 0ms; }
    @media (hover: hover) and (pointer: fine) {
        &:hover { background-color: rgba(0, 0, 0, 0.03); }
    }
`;

const LinkRow = styled(Row)`${pressable}`;


/* small app-icon square, same treatment as the company logos in the experience list */
const AppIcon = styled.span`
    width: 44px;
    height: 44px;
    flex: none;
    border-radius: 11px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    box-shadow: inset 0 0.5px 0 rgba(255, 255, 255, 0.4), 0 2px 6px rgba(0, 0, 0, 0.12), inset 0 0 0 0.5px rgba(0, 0, 0, 0.06);

    img { width: 100%; height: 100%; object-fit: cover; display: block; }
`;


const Timeline = styled.div`
    background: var(--surface);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    padding: 6px 0;
    overflow: hidden;
`;

const JobRow = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: 14px 44px 1fr auto;
    align-items: start;
    gap: 12px;
    padding: 14px 16px 14px 16px;

    &.current { background: linear-gradient(270deg, rgba(52, 199, 89, 0.07), transparent 70%); }

    /* phones: years drop under the text so the role gets the full width */
    @media (max-width: 520px) {
        grid-template-columns: 14px 44px 1fr;
        row-gap: 6px;
        & > :nth-child(1), & > :nth-child(2) { grid-row: 1 / span 2; }
        & > :nth-child(4) { grid-column: 3; grid-row: 2; justify-self: start; margin-top: 0; }
    }
`;

/* the timeline spine (RTL: on the right) */
const Rail = styled.div`
    position: relative;
    align-self: stretch;
    display: flex;
    justify-content: center;

    &::before {
        content: "";
        position: absolute;
        top: -14px;
        bottom: -14px;
        width: 1.5px;
        background: var(--separator);
    }
    /* spine starts at the first dot */
    ${Timeline} > ${JobRow}:first-child > &::before { top: 18px; }
`;

const Dot = styled.span`
    position: relative;
    margin-top: 16px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    box-shadow: 0 0 0 3px var(--surface);

    ${JobRow}.current &::after {
        content: "";
        position: absolute;
        inset: -5px;
        border-radius: 50%;
        border: 1.5px solid rgba(52, 199, 89, 0.45);
    }
`;

const Logo = styled.a`
    width: 44px;
    height: 44px;
    border-radius: 11px;     /* app-icon squircle-ish */
    overflow: hidden;
    text-decoration: none;
    transition: transform 160ms var(--ease);
    &:active { transform: scale(0.92); transition-duration: 60ms; }
    img { width: 100%; height: 100%; object-fit: cover; display: block; background: #fff; }
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    box-shadow: inset 0 0.5px 0 rgba(255, 255, 255, 0.4), 0 2px 6px rgba(0, 0, 0, 0.12);
`;

const JobText = styled.div`
    min-width: 0;
    text-align: right;
`;

const JobHead = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

`;

const CompanyLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -0.015em;
    color: var(--label);
    text-decoration: none;

    svg { color: var(--label-3); transition: color 160ms ease, transform 160ms var(--ease); }
    @media (hover: hover) {
        &:hover { color: var(--tint); }
        &:hover svg { color: var(--tint); transform: translate(-1px, -1px); }
    }
    &:active { opacity: 0.55; }
`;

const Now = styled.span`
    padding: 2px 8px;
    border-radius: 999px;
    background: rgba(52, 199, 89, 0.14);
    color: #248a3d;
    font-size: 11px;
    font-weight: 700;
`;

const Roleline = styled.div`
    font-size: 15px;
    line-height: 1.35;
    color: var(--label);
    text-align: right;
    opacity: 0.86;
`;

const Note = styled.div`
    margin-top: 3px;
    font-size: 13px;
    line-height: 1.4;
    color: var(--label-2);
`;

const YearPill = styled.span`
    margin-top: 2px;
    padding: 3px 9px;
    border-radius: 999px;
    background: rgba(118, 118, 128, 0.12);
    font-size: 12px;
    font-weight: 600;
    color: var(--label-2);
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
`;

const More = styled.div`
    display: grid;
    grid-template-rows: 0fr;
    opacity: 0;
    transition: grid-template-rows 520ms var(--ease), opacity 300ms ease;

    & > div { overflow: hidden; min-height: 0; }
    &.open { grid-template-rows: 1fr; opacity: 1; }

    @media (prefers-reduced-motion: reduce) {
        transition: opacity 200ms ease;
    }
`;

const MoreBtn = styled.button`
    ${capsule}
    ${glass}
    display: flex;
    margin: 10px auto 12px;
    min-height: 40px;
    padding: 0 18px;
    color: var(--tint);
    font-size: 15px;

    svg { transition: transform 420ms var(--ease); }
    svg.up { transform: rotate(180deg); }
`;

const SkillGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;

    @media (min-width: 560px) { grid-template-columns: 1fr 1fr; }
`;

const SkillCard = styled.div`
    background: var(--surface);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    padding: 14px;
`;

const SkillHead = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -0.01em;
`;

const SkillIcon = styled.span`
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: var(--c);
    box-shadow: inset 0 0.5px 0 rgba(255, 255, 255, 0.4);
`;

const Chips = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

const Chip = styled.span`
    padding: 5px 12px;
    border-radius: 999px;
    /* tinted fill from the category color */
    background: color-mix(in srgb, var(--c) 12%, transparent);
    color: color-mix(in srgb, var(--c) 78%, #000);
    font-size: 14px;
    font-weight: 600;
`;
